import { ReactNode, useState } from 'react';

import { CompareSelectionStateContext } from './CompareSelectionStateContext';

export interface CompareSelectionState {
    portId: string | null;
    supplierIds: string[];
    contractIds: string[];
}

interface CompareSelectionStateContextProviderProps {
    children: ReactNode;
    singleSupplierSelection?: boolean;
}

export const CompareSelectionStateContextProvider = ({
    children,
    singleSupplierSelection = false,
}: CompareSelectionStateContextProviderProps) => {
    const [selection, setSelection] = useState<CompareSelectionState>({
        portId: null,
        supplierIds: [],
        contractIds: [],
    });

    const contextValue = {
        selection,
        setSelection,
        singleSupplierSelection,
    };

    return (
        <CompareSelectionStateContext.Provider value={contextValue}>{children}</CompareSelectionStateContext.Provider>
    );
};
